let phoneNumberInput = document.getElementById("phoneNumber").value;
let nameInput = document.getElementById("name").value;
let emailInput = document.getElementById("email").value;
async function playOnClick() {
  phoneNumberInput = document.getElementById("phoneNumber").value;
  nameInput = document.getElementById("name").value;
  emailInput = document.getElementById("email").value;
  if (nameInput?.length <= 0 || phoneNumberInput?.length <= 0) {
    alert("Por favor, insira seu nome e telefone corretamente.");
    return;
  }

  const phonePattern = /^[0-9]+$/; // Expressão regular para validar números

  if (!phonePattern.test(phoneNumberInput)) {
    alert("Por favor, insira um número de telefone válido (apenas números).");
    return;
  }
  saveData({
    nome: nameInput,
    email: emailInput,
    phoneNumber: phoneNumberInput,
    //value: boxGanhador.innerHTML,
  });

  alert(
    `🎉 Parabéns!  **PLANNER RESERVADO**! 🎉\n\n` +
      `📌 **Regra:**APENAS 1 PEDIDO PARA GARANTIR\n\n`
  ); // globalObjects = {
  //   btnPlay: document.getElementById("btnPlay"),
  //   roleta: document.getElementById("roleta"),
  //   // btnStop: document.getElementById("btnStop")
  // };

  // globalObjects.timeInitial = new Date();
  // globalObjects.btnPlay.style.visibility = "hidden";
  // // globalObjects.btnStop.style.visibility = "visible";
  // globalObjects.roleta.style.animation = "roleta 2s linear infinite";

  // // Defina o próximo intervalo com um valor aleatório entre 2 e 5 segundos
  // const nextInterval = 3100; //Math.floor(Math.random() * (5000 - 2000 + 1)) + 2000;

  // // Use setTimeout para definir o próximo intervalo
  // //setTimeout(stopOnClick, nextInterval);
  // setTimeout(initStopOnClick, nextInterval);
}

async function saveData(payload) {
  console.log("bater em api para salvar dados: ", payload);
  const url = "https://noro.vercel.app/user/roulette";

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (response.status !== 201) {
      throw new Error(`Erro: ${response.status} ${response.statusText}`);
    }

    //console.log("Resposta do servidor:", response);
  } catch (error) {
    console.error("Erro ao enviar dados:", error);
  }
}

function calculate() {
  var timeFinal = new Date();
  var tempo = Math.abs(timeFinal - globalObjects.timeInitial);
  var box = parseInt(tempo / 250);
  if (box > 7) box = parseInt(box % 8);

  console.log(globalObjects.timeInitial, timeFinal, tempo, box, tempo / 250);
  return box;
}

async function stopOnClick() {
  globalObjects.roleta.style["animation-play-state"] = "paused";
}

let cupomGlobal = "";
function copiaCola() {
  navigator.clipboard
    .writeText(cupomGlobal)
    .then(() => {
      alert("O código foi copiado para a área de transferência!");
    })
    .catch((err) => {
      console.error("Erro ao copiar o cupom: ", err);
      alert("Erro ao copiar o cupom. Tente novamente.");
    });
}

async function initStopOnClick() {
  // Copiar o cupom para a área de transferência
  await stopOnClick();
  await getWinner();
}

async function getWinner() {
  var box = calculate();
  var boxGanhador = document.getElementById("opt".concat(box));

  await new Promise((resolve) => setTimeout(resolve, 100)); // 100 ms de espera

  let cupom = "";

  if (boxGanhador.innerHTML == "R$ 50,00") {
    //cupom = "NORO2410";
    //cupomGlobal = "NORO2410";

    alert(
      `🎉 Parabéns!  **CONCORRENDO A R$ 50,00**! 🎉\n\n` +
        `📌 **Regra:**APENAS 1 PEDIDO PARA PARTICIPAR\n\n`
    );
  } else if (boxGanhador.innerHTML == "R$ 75,00") {
    cupom = "NORO15";
    cupomGlobal = "NORO15";

    // alert(
    //   `🎉 Parabéns! Você ganhou **15% de desconto**! 🎉\n\n` +
    //     `📝 **Cupom:** ${cupom}\n` +
    //     `📌 **Regra:** PEDIDO ACIMA DE R$ 99,00\n\n` +
    //     `📋 Clique no botão para copiar o Cupom.`
    // );
    alert(
      `🎉 Parabéns!  **CONCORRENDO A R$ 75,00**! 🎉\n\n` +
        `📌 **Regra:**APENAS 1 PEDIDO PARA PARTICIPAR\n\n`
    );
  } else if (boxGanhador.innerHTML == "R$ 100,00") {
    cupom = "NOROACE5";
    cupomGlobal = "NOROACE5";

    // alert(
    //   `🎉 Parabéns! Você ganhou **5% de desconto**! 🎉\n\n` +
    //     `📝 **Cupom:** ${cupom}\n` +
    //     `📌 **Regra:** PEDIDO ACIMA DE R$ 99,00\n\n` +
    //     `📋 Clique no botão para copiar o Cupom.`
    // );
    alert(
      `🎉 Parabéns!  **CONCORRENDO A R$ 100,00**! 🎉\n\n` +
        `📌 **Regra:**APENAS 1 PEDIDO PARA PARTICIPAR\n\n`
    );
  }
  //document.querySelector(".botaoCopiar").style.display = "block";
  //Save data
  saveData({
    nome: nameInput,
    email: emailInput,
    phoneNumber: phoneNumberInput,
    value: boxGanhador.innerHTML,
  });
}

function closeModal() {
  setCookie("modalClosed", "novacolecao", "3");
  const modal = document.getElementById("modalRoleta");
  modal.style.visibility = "hidden";
}

function closeModalRules() {
  const modalRules = document.getElementById("modal-roleta-rules-close-id");
  modalRules.style.visibility = "hidden";
}

function openModalRules() {
  const modalRules = document.getElementById("modal-roleta-rules-close-id");
  modalRules.style.visibility = "visible";
}

// Função para criar cookie
function setCookie(name, value, hours) {
  const d = new Date();
  d.setTime(d.getTime() + hours * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

// Função para obter o valor de um cookie
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.slice(1);
    if (c.indexOf(nameEQ) === 0) return c.slice(nameEQ.length, c.length);
  }
  return null;
}

// Função para verificar se o modal deve ser exibido
function checkModal() {
  const modalClosed = getCookie("modalClosed");
  if (modalClosed) {
    const now = new Date();
    const cookieValue = JSON.parse(modalClosed); // Supõe que o valor do cookie é um objeto com a data de expiração
    const expirationDate = new Date(cookieValue.expiration);

    // Verifica se o cookie já expirou
    if (now > expirationDate) {
      // O cookie expirou
      document.getElementById("modalRoleta").style.visibility = "visible"; // Mostra o modal
    } else {
      // O cookie não expirou
      document.getElementById("modalRoleta").style.visibility = "hidden"; // Esconde o modal
    }
  } else {
    // Se o cookie não existir, mostra o modal
    document.getElementById("modalRoleta").style.visibility = "visible"; // Mostra o modal
  }
}
